module.exports = __webpack_public_path__ + "img/step-2.f856cbb9.png";